import { useEffect, useState } from "react";
import { getApiBase } from "../helpers/apiBase";
import { readLocationCache, writeLocationCache } from "../helpers/locationCache";

/**
 * Загрузка локации по location_id из query: кэш localStorage `location`, иначе POST /v1/location/item.
 */
export const useLocationItem = (locationIdParam) => {
  const locationId = locationIdParam ? parseInt(locationIdParam, 10) : NaN;

  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!locationIdParam || Number.isNaN(locationId) || locationId < 1) {
      setError("Укажите корректный параметр location_id в адресе страницы.");
      setLoading(false);
      setLocation(null);
      return;
    }

    const cached = readLocationCache();
    if (cached && cached.id === locationId) {
      setLocation(cached);
      setLoading(false);
      setError("");
      return;
    }

    const load = async () => {
      const base = getApiBase();
      if (!base) {
        setError("Не задан REACT_APP_FW_API для запросов к API.");
        setLoading(false);
        setLocation(null);
        return;
      }

      setLoading(true);
      setError("");
      try {
        const token = localStorage.getItem("token");
        const headers = {
          "Content-Type": "application/json",
        };
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }
        const res = await fetch(`${base}/v1/location/item`, {
          method: "POST",
          headers,
          body: JSON.stringify({ id: locationId }),
        });
        const data = await res.json().catch(() => ({}));
        if (res.status === 401) {
          setError("Вы не авторизованы или сессия истекла. Перезайдите в cpai.");
          setLocation(null);
          return;
        }
        if (!res.ok) {
          setError(
            data && data.message
              ? data.message
              : `Ошибка загрузки локации (код ${res.status}).`
          );
          setLocation(null);
          return;
        }
        if (data && typeof data.name === "string") {
          writeLocationCache(data);
          setLocation(data);
        } else {
          setError("Локация не найдена.");
          setLocation(null);
        }
      } catch (e) {
        setError("Ошибка сети при загрузке локации.");
        setLocation(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [locationId, locationIdParam]);

  return { location, loading, error, locationId };
};
